import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  formData: {
    advance: "",
    Pagdi: "",
    dwrname: "",
    transvalue: 0,
    modePayment: null,
    exedate: null,
    page: "",
    word: "",
    regfeeMin: null,
    regfeeMax: null,
    regPct: null,
    minstamp: null,
    stamppct: null,
    maxstamp: null,
    leasePeriod: 0,
    avgRent: 0,
    mvalue: 0,
    rfee: 0,
    stampduty: "",
    landcost: 0,
    structcost: 0,
    selectedSRO: "",
  },
};

const propertyEvaluationInputSlice = createSlice({
  name: "propertyEvaluation",
  initialState,
  reducers: {
    updatePropertyEvaluationForm: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    resetPropertyEvaluationForm: (state) => {
      state.formData = initialState.formData;
      //   state.isSaved = false;
    },
    setFormSaveStatus: (state, action) => {
      state.isSaved = action.payload; // Set save status
    },
  },
});

export const {
  updatePropertyEvaluationForm,
  resetPropertyEvaluationForm,
  setFormSaveStatus,
} = propertyEvaluationInputSlice.actions;

export default propertyEvaluationInputSlice.reducer;
